(function () {
  let prevCartGiftState = {};
  let giftReaddSkipActive = {};

  function giftSkipKey(variantId) {
    return 'cart_goal_gift_skip_' + String(variantId);
  }

  function variantIdEquals(a, b) {
    if (a == null || b == null) return false;
    return Number(a) === Number(b);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function applyCartSections(sections) {
    if (!sections) return;
    const parse = (html, selector) => {
      const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return node ? node.innerHTML : '';
    };
    const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (sections['cart-drawer'] && drawerInner) {
      const inner = parse(sections['cart-drawer'], '.drawer__inner');
      if (inner) drawerInner.innerHTML = inner;
    }
    const bubbleHost = document.getElementById('cart-icon-bubble');
    if (sections['cart-icon-bubble'] && bubbleHost) {
      const bubbleReplace = bubbleHost.querySelector('.shopify-section') || bubbleHost;
      const bubbleHtml = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubbleHtml) bubbleReplace.innerHTML = bubbleHtml;
    }
  }

  function formatMoney(cents, currency) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }
    const code = currency || 'GBP';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  async function fetchCartJson() {
    const cartJs =
      window.routes && window.routes.cart_url
        ? window.routes.cart_url.replace(/\/?$/, '') + '.js'
        : '/cart.js';
    const res = await fetch(cartJs, { headers: { Accept: 'application/json' } });
    return await res.json();
  }

  function getSubtotalForGoals(cart) {
    if (!cart) return 0;
    if (typeof cart.original_total_price === 'number') return cart.original_total_price;
    if (typeof cart.items_subtotal_price === 'number') return cart.items_subtotal_price;
    if (typeof cart.total_price === 'number') return cart.total_price;
    return 0;
  }

  function getLinePriceForGoals(item) {
    if (!item) return 0;
    if (typeof item.original_line_price === 'number') return item.original_line_price;
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    return 0;
  }

  function isAutoGiftItem(item) {
    return item.properties && String(item.properties._cart_goal_auto) === '1';
  }

  function isGiftVariant(item, giftVariantIds) {
    return giftVariantIds.some(function (vid) {
      return variantIdEquals(item.variant_id, vid);
    });
  }

  function isExcludedItem(item, excludedProductIds) {
    return excludedProductIds.some(function (pid) {
      return variantIdEquals(item.product_id, pid);
    });
  }

  // Excluded products (e.g. gift cards) count toward free shipping
  // but not toward the free gift, so each goal tracks its own subtotal.
  function computeGoalSubtotals(cart, giftVariantIds, excludedProductIds) {
    let shipping = getSubtotalForGoals(cart);
    let excludedTotal = 0;
    const items = (cart && cart.items) || [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (isAutoGiftItem(item) && isGiftVariant(item, giftVariantIds)) {
        shipping -= getLinePriceForGoals(item);
      } else if (isExcludedItem(item, excludedProductIds)) {
        excludedTotal += getLinePriceForGoals(item);
      }
    }
    return { shipping: shipping, gift: shipping - excludedTotal };
  }

  class CartGoals extends HTMLElement {
    connectedCallback() {
      const cfgScript = this.querySelector('[data-cart-goals-config]');
      if (!cfgScript) return;
      try {
        this.cfg = JSON.parse(cfgScript.textContent);
      } catch (e) {
        return;
      }
      this.messageEl = this.querySelector('[data-cart-goals-message]');
      this.trackEl = this.querySelector('[data-cart-goals-track]');
      this.milestoneShipping = this.querySelector('[data-cart-goals-milestone-shipping]');
      this.milestoneGift = this.querySelector('[data-cart-goals-milestone-gift]');
      this._giftSyncLock = false;

      // Normalize giftVariantIds and excludedProductIds to arrays of numbers
      var ids = this.cfg.giftVariantIds;
      if (!Array.isArray(ids)) ids = [];
      this.cfg.giftVariantIds = ids.filter(function (id) { return id != null; }).map(Number);
      var exclIds = this.cfg.excludedProductIds;
      if (!Array.isArray(exclIds)) exclIds = [];
      this.cfg.excludedProductIds = exclIds.filter(function (id) { return id != null; }).map(Number);

      const debounced =
        typeof debounce === 'function'
          ? debounce((event) => {
              void this.refreshFromCart(event);
            }, 250)
          : (event) => {
              void this.refreshFromCart(event);
            };
      this._onCartUpdated = (event) => debounced(event);
      document.addEventListener('cart:updated', this._onCartUpdated);
      void this.refreshFromCart();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
    }

    async refreshFromCart(event) {
      let cart;
      const fromEvent = event && event.detail && Array.isArray(event.detail.items);
      if (fromEvent) {
        cart = event.detail;
      } else {
        try {
          const cartJs =
            window.routes && window.routes.cart_url
              ? window.routes.cart_url.replace(/\/?$/, '') + '.js'
              : '/cart.js';
          const res = await fetch(cartJs, {
            headers: { Accept: 'application/json' },
          });
          cart = await res.json();
        } catch (e) {
          return;
        }
      }

      const giftVariantIds = this.cfg.giftVariantIds;
      const giftCents = this.cfg.giftCents;
      const giftEnabled = this.cfg.giftEnabled !== false;

      if (giftEnabled && giftVariantIds.length > 0 && giftCents > 0) {
        for (var vi = 0; vi < giftVariantIds.length; vi++) {
          var vid = giftVariantIds[vi];
          var hasAuto = cart.items.some(function (item) {
            return variantIdEquals(item.variant_id, vid) && isAutoGiftItem(item);
          });
          var prev = prevCartGiftState[vid];
          if (prev && prev.hadAuto && !hasAuto) {
            // User removed the auto-added gift — track the skip
            var subForGoal = computeGoalSubtotals(cart, giftVariantIds, this.cfg.excludedProductIds).gift;
            if (subForGoal >= giftCents) {
              giftReaddSkipActive[vid] = true;
              try { sessionStorage.setItem(giftSkipKey(vid), '1'); } catch (e) {}
            }
          }
          prevCartGiftState[vid] = { hadAuto: hasAuto };
        }
      }

      const didMutate = await this.syncGiftCart(cart);
      if (!didMutate) {
        this.renderFromCart(cart);
      }
    }

    applyAmountTemplate(template, remainingCents) {
      const amt = formatMoney(Math.max(0, remainingCents), this.cfg.currency);
      const tpl = template || '';
      if (!tpl.includes('{{amount}}')) {
        return escapeHtml(tpl);
      }
      return tpl
        .split('{{amount}}')
        .map((p) => escapeHtml(p))
        .join('<span class="cart-goals__strong">' + amt + '</span>');
    }

    renderFromCart(cart) {
      if (!this.messageEl || !this.trackEl || !this.cfg) return;
      const giftVariantIds = this.cfg.giftVariantIds;
      const subtotals = computeGoalSubtotals(cart, giftVariantIds, this.cfg.excludedProductIds);
      const ship = this.cfg.shippingCents;
      const gift = this.cfg.giftCents;
      const giftEnabled = this.cfg.giftEnabled !== false;
      const target = giftEnabled && gift > 0 ? gift : ship;
      const fillSubtotal = giftEnabled && gift > 0 ? subtotals.gift : subtotals.shipping;
      let fill = 0;
      if (target > 0) {
        fill = Math.min(100, (fillSubtotal / target) * 100);
      }
      // Shipping progress (which still counts excluded products) can fill
      // the shared track up to the shipping milestone's position
      if (giftEnabled && gift > 0 && ship > 0) {
        const shipPct = typeof this.cfg.shippingPct === 'number' ? this.cfg.shippingPct : Math.min(100, (ship / gift) * 100);
        const shipFill = Math.min(shipPct, (subtotals.shipping / ship) * shipPct);
        fill = Math.max(fill, shipFill);
      }
      const fillRounded = Math.round(fill * 100) / 100;
      this.trackEl.style.setProperty('--cart-goals-fill-pct', fillRounded + '%');

      if (this.milestoneShipping) {
        this.milestoneShipping.classList.toggle('is-complete', subtotals.shipping >= ship);
      }
      if (giftEnabled && this.milestoneGift) {
        this.milestoneGift.classList.toggle('is-complete', subtotals.gift >= gift);
      }

      if (giftEnabled) {
        if (subtotals.gift >= gift) {
          this.messageEl.textContent = this.cfg.messageSuccess || '';
        } else if (subtotals.shipping >= ship) {
          const rem = gift - subtotals.gift;
          this.messageEl.innerHTML = this.applyAmountTemplate(this.cfg.messageGift, rem);
        } else {
          const rem = ship - subtotals.shipping;
          this.messageEl.innerHTML = this.applyAmountTemplate(this.cfg.messageShipping, rem);
        }
      } else {
        if (subtotals.shipping >= ship) {
          this.messageEl.textContent = this.cfg.messageShippingSuccess || '';
        } else {
          const rem = ship - subtotals.shipping;
          this.messageEl.innerHTML = this.applyAmountTemplate(this.cfg.messageShipping, rem);
        }
      }
    }

    async syncGiftCart(cart) {
      if (this._giftSyncLock) return false;
      this._giftSyncLock = true;
      try {
        if (this.cfg.giftEnabled === false) {
          const toRemove = [];
          for (let i = 0; i < cart.items.length; i++) {
            const item = cart.items[i];
            if (isAutoGiftItem(item)) {
              toRemove.push({
                line: i + 1,
                key: item.key != null ? String(item.key) : null,
              });
            }
          }
          if (toRemove.length > 0) {
            return await this.postGiftRemoveMultiple(toRemove);
          }
          return false;
        }

        const giftVariantIds = this.cfg.giftVariantIds;
        if (!giftVariantIds.length) return false;
        const giftCents = this.cfg.giftCents;

        // Gift-goal subtotal excludes auto-added gifts and excluded products
        const subtotal = computeGoalSubtotals(cart, giftVariantIds, this.cfg.excludedProductIds).gift;
        const autoLines = {}; // vid -> { line, key }
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          if (isAutoGiftItem(item) && isGiftVariant(item, giftVariantIds)) {
            const matchedVid = giftVariantIds.find(function (vid) {
              return variantIdEquals(item.variant_id, vid);
            });
            if (matchedVid != null) {
              autoLines[matchedVid] = {
                line: i + 1,
                key: item.key != null ? String(item.key) : null,
              };
            }
          }
        }

        // If subtotal dropped below threshold, clear all skip flags
        if (subtotal < giftCents) {
          for (var vi = 0; vi < giftVariantIds.length; vi++) {
            var vid = giftVariantIds[vi];
            giftReaddSkipActive[vid] = false;
            try { sessionStorage.removeItem(giftSkipKey(vid)); } catch (e) {}
          }
        }

        if (subtotal >= giftCents) {
          // Add all gift variants that are not yet in cart
          const toAdd = [];
          for (var ai = 0; ai < giftVariantIds.length; ai++) {
            var addVid = giftVariantIds[ai];
            var alreadyInCart = cart.items.some(function (item) {
              return variantIdEquals(item.variant_id, addVid);
            });
            if (!alreadyInCart) {
              var skipByStorage = false;
              try { skipByStorage = sessionStorage.getItem(giftSkipKey(addVid)) === '1'; } catch (e) {}
              if (!giftReaddSkipActive[addVid] && !skipByStorage) {
                toAdd.push(addVid);
              }
            }
          }
          if (toAdd.length > 0) {
            return await this.postGiftAddMultiple(toAdd);
          }
        } else {
          // Remove all auto-added gift items when below threshold
          const toRemove = [];
          for (var ri = 0; ri < giftVariantIds.length; ri++) {
            var remVid = giftVariantIds[ri];
            if (autoLines[remVid]) {
              toRemove.push(autoLines[remVid]);
            }
          }
          if (toRemove.length > 0) {
            return await this.postGiftRemoveMultiple(toRemove);
          }
        }

        return false;
      } finally {
        this._giftSyncLock = false;
      }
    }

    postGiftAddMultiple(variantIds) {
      const items = variantIds.map(function (vid) {
        return {
          id: vid,
          quantity: 1,
          properties: { _cart_goal_auto: '1' },
        };
      });
      const body = {
        items: items,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      };
      return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        ...fetchConfig(),
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then(async (data) => {
          if (data.status) return false;
          applyCartSections(data.sections);
          try {
            const cart = await fetchCartJson();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          } catch (e) {}
          return true;
        })
        .catch(() => false);
    }

    postGiftRemoveMultiple(linesToRemove) {
      // Shopify /cart/update.js supports setting quantities for multiple items by key
      const updates = {};
      const keys = [];
      for (var i = 0; i < linesToRemove.length; i++) {
        var entry = linesToRemove[i];
        if (entry.key) {
          updates[entry.key] = 0;
          keys.push(entry.key);
        }
      }
      if (keys.length === 0) {
        // Fallback: remove one at a time by line (shouldn't normally happen)
        if (linesToRemove.length > 0 && linesToRemove[0].line) {
          return this.postGiftRemoveSingle(linesToRemove[0].line, null);
        }
        return Promise.resolve(false);
      }
      const body = {
        updates: updates,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      };
      return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
        ...fetchConfig(),
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then(async (data) => {
          if (!data || data.errors) return false;
          applyCartSections(data.sections);
          try {
            const cart = await fetchCartJson();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          } catch (e) {}
          return true;
        })
        .catch(() => false);
    }

    postGiftRemoveSingle(line, lineKey) {
      const body = {
        quantity: 0,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      };
      if (lineKey) {
        body.id = lineKey;
      } else if (line != null && line >= 1) {
        body.line = line;
      } else {
        return Promise.resolve(false);
      }
      return fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
        ...fetchConfig(),
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then(async (data) => {
          if (!data || data.errors) return false;
          if (!data.sections) return false;
          applyCartSections(data.sections);
          try {
            const cart = await fetchCartJson();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          } catch (e) {}
          return true;
        })
        .catch(() => false);
    }
  }

  if (!customElements.get('cart-goals')) {
    customElements.define('cart-goals', CartGoals);
  }
})();
